import { useTranslation } from "react-i18next";

import { CreateCampaignButton } from "../ui/CreateCampaignButton";

import CampaignsIcon from "@/shared/assets/icons/campaignsIcon.svg";
import ClipboardIcon from "@/shared/assets/icons/clipboardIcon.svg";
import CreativeIcon from "@/shared/assets/icons/creativesIcon.svg";
import LinkIcon from "@/shared/assets/icons/linkIcon.svg";
import { ROUTES } from "@/shared/config";

export const useGetSidebarItems = (open: boolean) => {
    const { t } = useTranslation();
    const items = [
        {
            key: "0",
            label: <CreateCampaignButton open={open} />,
        },
        {
            key: ROUTES.CAMPAIGNS,
            label: open ? t("sidebar.navs.campaigns") : "",
            icon: <CampaignsIcon />,
            qaTag: "menu-campaigns-link",
        },
        {
            key: "/reports",
            label: open ? t("sidebar.navs.reports") : "",
            icon: <ClipboardIcon />,
            qaTag: "menu-reports-link",
        },
        {
            key: "/assets",
            label: open ? t("sidebar.navs.assets") : "",
            icon: <LinkIcon />,
            qaTag: "menu-assets-link",
        },
        {
            key: "/creatives",
            label: open ? t("sidebar.navs.creatives") : "",
            icon: <CreativeIcon />,
            qaTag: "menu-creatives-link",
        },
    ];
    return items;
};
